import { render } from "./EstrattiContoDetail.vue?vue&type=template&id=12d5a7bb&scoped=true"
import script from "./EstrattiContoDetail.vue?vue&type=script&lang=js"
export * from "./EstrattiContoDetail.vue?vue&type=script&lang=js"

import "./EstrattiContoDetail.vue?vue&type=style&index=0&id=12d5a7bb&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d5a7bb"]])

export default __exports__